import React from 'react'
import styled from "styled-components";
import { darken } from 'polished'

import { __ } from '~/i18n'

const PoweredByContainer = styled.div`
  text-align: center;
  padding: 30px 0;
  
  a {
    font-size: 12px;
    color: #B4B4B4;
    letter-spacing: 0.2px;
    text-align: center;
    line-height: 12px;
    
    &:hover {
      color: ${props => darken(0.1, '#B4B4B4')};
    }
  }
`;

export default class PoweredBy extends React.PureComponent {
  render() {
    return (
      <PoweredByContainer><a href="https://gratify.eu/?utm_source=gratify_cart" target="_blank">{ __('Powered by Gratify') }</a></PoweredByContainer>
    )
  }
}